import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import AnimatedBackground from "@/components/AnimatedBackground";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import aivinityWeb from "@/assets/aivinity-web.png";
import aivinityVideo from "@/assets/aivinity-video.png";
import SEO from "@/components/SEO";

const ImpressumPage = () => {
  return (
    <main className="min-h-screen bg-background relative">
      <SEO
        title="Impressum | 22 Studios Nürnberg"
        description="Impressum von 22 Studios Nürnberg – Angaben gemäß § 5 TMG, Kontaktdaten und rechtliche Hinweise."
        canonical="https://22studios.de/nuernberg/impressum"
      />
      <AnimatedBackground />
      <Navigation />

      <section className="pt-24 pb-12 md:pt-32 md:pb-20 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-serif text-display-lg md:text-display-xl mb-3 md:mb-4 text-foreground">
            Impressum
          </h1>
          <div className="h-1 w-20 bg-primary rounded-full mb-8 md:mb-12" />

          <div className="space-y-6 md:space-y-10 text-foreground/80 leading-relaxed">
            {/* Angaben gemäß § 5 TMG */}
            <div className="glass rounded-2xl p-5 md:p-8 border border-border/50">
              <h2 className="font-serif text-heading text-foreground mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <p className="text-lg font-medium text-foreground mb-1">Vorname Nachname</p>
              <p>handelnd unter „22 Studios"</p>
              <p>Deidesheimer Str. 4</p>
              <p>90469 Nürnberg</p>
              <p>Deutschland</p>
            </div>

            {/* Kontakt */}
            <div className="glass rounded-2xl p-5 md:p-8 border border-border/50">
              <h2 className="font-serif text-heading text-foreground mb-4">Kontakt</h2>
              <p>
                Telefon:{" "}
                <a href="tel:+4915172530302" className="text-highlight hover:underline">
                  +49 151 7253 0302
                </a>
              </p>
              <p>
                E-Mail:{" "}
                <a href="mailto:info@22studios.de" className="text-highlight hover:underline">
                  info@22studios.de
                </a>
              </p>
            </div>

            {/* USt-ID */}
            <div className="glass rounded-2xl p-5 md:p-8 border border-border/50">
              <h2 className="font-serif text-heading text-foreground mb-4">
                Umsatzsteuer-ID
              </h2>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:{" "}
                <span className="font-medium text-foreground">DE361521498</span>
              </p>
            </div>

            {/* Streitschlichtung */}
            <div className="glass rounded-2xl p-5 md:p-8 border border-border/50">
              <h2 className="font-serif text-heading text-foreground mb-4">
                EU-Streitschlichtung
              </h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-highlight hover:underline break-all"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="mt-2">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </div>

            <div className="glass rounded-2xl p-5 md:p-8 border border-border/50">
              <h2 className="font-serif text-heading text-foreground mb-4">
                Verbraucherstreitbeilegung / Universalschlichtungsstelle
              </h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            {/* Haftungsausschluss */}
            <div className="glass rounded-2xl p-5 md:p-8 border border-border/50">
              <h2 className="font-serif text-heading text-foreground mb-4">
                Haftung für Inhalte
              </h2>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen.
              </p>
              <p className="mt-3">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                Informationen nach den allgemeinen Gesetzen bleiben hiervon
                unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
                wir diese Inhalte umgehend entfernen.
              </p>
            </div>

            <div className="glass rounded-2xl p-5 md:p-8 border border-border/50">
              <h2 className="font-serif text-heading text-foreground mb-4">
                Haftung für Links
              </h2>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich.
              </p>
            </div>

            <div className="glass rounded-2xl p-5 md:p-8 border border-border/50">
              <h2 className="font-serif text-heading text-foreground mb-4">
                Urheberrecht
              </h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>

            {/* Aivinity Credits */}
            <div className="relative rounded-3xl p-6 md:p-10 bg-black border border-white/10 overflow-hidden">
              {/* Decorative gradient orbs */}
              <div className="absolute -top-20 -right-20 w-60 h-60 bg-purple-600/20 rounded-full blur-3xl animate-pulse-soft" />
              <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-emerald-600/15 rounded-full blur-3xl animate-pulse-soft" style={{ animationDelay: '4s' }} />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-white/5 rounded-full blur-2xl animate-breathe" />

              <h2 className="relative font-serif text-heading text-white text-center mb-2">
                Kreation & Umsetzung
              </h2>
              <p className="relative text-sm text-white/50 text-center mb-10">
                Diese Webseite wurde realisiert von
              </p>

              <div className="relative grid sm:grid-cols-2 gap-4 md:gap-6">
                {/* Aivinity Video */}
                <a
                  href="https://aivinity.de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex flex-col justify-between p-5 md:p-8 rounded-2xl bg-white/[0.04] border border-white/[0.08] backdrop-blur-sm hover:bg-white/[0.08] hover:border-emerald-500/30 hover:shadow-[0_0_40px_rgba(16,185,129,0.15)] transition-all duration-500"
                >
                  <div>
                    <img
                      src={aivinityVideo}
                      alt="aivinity video"
                      className="h-8 w-auto object-contain mb-5 group-hover:scale-105 transition-transform duration-500"
                    />
                    <p className="font-semibold text-white text-lg mb-1">
                      Bildmaterial
                    </p>
                    <p className="text-sm text-white/40 leading-relaxed">
                      High-End Foto- und Videoaufnahmen für diese Webseite.
                    </p>
                  </div>
                  <div className="flex justify-end mt-4">
                    <span className="w-8 h-8 rounded-full border border-white/15 flex items-center justify-center text-white/40 group-hover:text-emerald-400 group-hover:border-emerald-400/40 transition-colors">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                    </span>
                  </div>
                </a>

                {/* Aivinity Web */}
                <a
                  href="https://web.aivinity.de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex flex-col justify-between p-5 md:p-8 rounded-2xl bg-white/[0.04] border border-white/[0.08] backdrop-blur-sm hover:bg-white/[0.08] hover:border-purple-500/30 hover:shadow-[0_0_40px_rgba(147,51,234,0.15)] transition-all duration-500"
                >
                  <div>
                    <img
                      src={aivinityWeb}
                      alt="aivinity web"
                      className="h-8 w-auto object-contain mb-5 group-hover:scale-105 transition-transform duration-500"
                    />
                    <p className="font-semibold text-white text-lg mb-1">
                      Webdesign
                    </p>
                    <p className="text-sm text-white/40 leading-relaxed">
                      Echte Webseiten, die Konvertieren – fertig in 7 Tagen.
                    </p>
                  </div>
                  <div className="flex justify-end mt-4">
                    <span className="w-8 h-8 rounded-full border border-white/15 flex items-center justify-center text-white/40 group-hover:text-purple-400 group-hover:border-purple-400/40 transition-colors">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                    </span>
                  </div>
                </a>
              </div>

              {/* Footer line */}
              <p className="relative text-center text-sm text-white/30 mt-8">
                hello@aivinity.de &nbsp;•&nbsp; Aachen
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTopButton />
    </main>
  );
};

export default ImpressumPage;
